const DEVICE_ID_KEY = 'ifind_device_id';

export const getPersistentDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
      deviceId = crypto.randomUUID();
    } else {
      // Fallback: timestamp-based pseudo-uuid
      deviceId = `${Date.now()}-${Math.floor(Math.random() * 1e12)}`;
    }
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}; 